export class ContactBasicResultDto {
  contactId: number;
  contactName: string;
  contactTypeId: number;
}
